import formatFileSize from './utils'

const messages = {
  _default: () => `įrašas netinkamas.`,
  after: (field, [target, inclusion]) =>
    `turi būti po ${inclusion ? 'arba lygu ' : ''}${target}.`,
  alpha_dash: () =>
    `įrašyti galima tik raides, skaitmenis brūkšnius ir apatinius brūkšnius.`,
  alpha_num: () =>
    `įrašyti galima tik raides ir skaitmenis `,
  alpha_spaces: () =>
    `įrašyti galima tik raides, skaitmenis ir tarpus `,
  alpha: () => `įrašyti galima tik raides `,
  before: (field, [target, inclusion]) =>
    `turi būti prieš ${inclusion ? 'arba lygu ' : ''}${target}.`,
  between: (field, [min, max]) =>
    `vertė turi būti tarp ${min} ir ${max}.`,
  confirmed: () => `pakartota reikšmė nesutampa su pirmine.`,
  credit_card: () => `įrašas netinkamas.`,
  date_between: (field, [min, max]) =>
    `turi būti tarp ${min} ir ${max}.`,
  date_format: (field, [format]) =>
    `formatas turi būti ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `įrašyti galima tik skaitmenis ir  ${!decimals || decimals === '*' ? '' : decimals
    } skiriamuosius ženklus.`,
  digits: (field, [length]) =>
    `įrašyti galima tik skaitmenis ir tik tokį skaitmenų skaičių: ${length}`,
  dimensions: (field, [width, height]) =>
    `dydis turi būti ${width} x ${height} pikselių.`,
  email: () => `email adresas turi būti galiojantis.`,
  ext: () => `turi būti teisingas failas.`,
  image: () => `turi būti paveikslėlis.`,
  in: () => `turi būti tinkamas įrašas.`,
  integer: () => `turi būti skaičius.`,
  ip: () => `turi būti galiojantis IP adresas.`,
  length: (field, [length, max]) => {
    if (max) {
      return `ilgis turi būti tarp ${length} ir${max}.`
    }

    return `ilgis turi būti ${length}.`
  },
  max: (field, [length]) =>
    `lauke negali būti daugiau nei ${length} simbolių.`,
  max_value: (field, [max]) => `laukas turi būti ${max} arba mažiau.`,
  mimes: () => `turi būti tinkamas failo tipas.`,
  min: (field, [length]) =>
    `turi būti bent ${length} simbolių.`,
  min_value: (field, [min]) =>  `turi būti ${min} arba daugiau.`,
  not_in: () =>  `turi būti tinkamas įrašas.`,
  numeric: () => `įrašyti galima tik skaitmenis `,
  regex: () =>  `failo tipas netinkamas.`,
  required: () =>  `laukas privalomas.`,
  size: (field, [size]) =>
  `dydis turi būti mažiau nei ${formatFileSize(size)}.`,
  url: () =>  `URL nėra tinkamas`,
  fullName: () => 'nėra tinkamas (vardas ir pavardė max 20 simbolių)',
  emailInput: () => 'turi būti tinkasmas elektroninis paštas',
  fullNamePerCountry: () => 'nėra tinkamas (vardas ir pavardė max 18 simbolių)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'lt',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/lt.js